import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@material-ui/core'

import { useSelector } from 'react-redux'
import * as tourOverviewActions from 'actions/tourOverview'
import * as fromTourOverview from 'selectors/tourOverview'

import { TourOverview } from 'common/models/typings/TourOverview'

import Typography from 'common/components/base/Typography'
import NoActiveTour from 'common/components/features/EmptyState/NoActiveTour'
import MonitoringLegends from 'common/components/features/Monitoring/Legends'
import TourLegends from 'common/components/features/Monitoring/TourLegends'

import { useAppDispatch } from 'planner-upgrades/redux/hooks'

const MonitoringPage = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const [isAlreadyBootstrap, setIsAlreadyBootstrap] =
    React.useState<boolean>(false)

  const { bootstrapping } = useSelector((state: any) => state.ui)
  const tourOverview: TourOverview[] = useSelector(
    fromTourOverview.getTourOverviews,
  )

  React.useEffect(() => {
    if (!bootstrapping && !isAlreadyBootstrap) {
      dispatch(tourOverviewActions.fetchTourOverviews())
      setIsAlreadyBootstrap(true)
    }
  }, [dispatch, bootstrapping, isAlreadyBootstrap])

  const tourLegendCards = React.useMemo(
    () =>
      tourOverview.map((overview, index) => (
        <React.Fragment key={overview.tour.id}>
          <TourLegends
            tour={overview.tour}
            collations={overview.collations}
            driver={overview.driver}
          />
          {tourOverview.length !== index + 1 && <Box height={16} />}
        </React.Fragment>
      )),
    [tourOverview],
  )

  if (tourOverview.length < 1) {
    return <NoActiveTour />
  }

  return (
    <div className="mr-[-32px]">
      <div className="overflow-y-scroll max-h-[100vh] pr-[32px] pb-32">
        <MonitoringLegends />
        <div className="h-4" />
        {tourLegendCards}
      </div>
    </div>
  )
}

export default MonitoringPage
